<template>
  <v-bottom-navigation
    color="white"
    horizontal
    app
    background-color="#2b91f6"
  >
    <v-btn min-width="50%" class="contact-text" color="#2380dc">
      <span>{{ contacttext }}</span>
    </v-btn>
    <v-btn @click.stop="dial" min-width="25%" class="call-button">
      <v-icon>mdi-phone</v-icon>
    </v-btn>

    <v-btn @click.stop="sendmail" min-width="25%">
      <v-icon>mdi-email-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        data () {
            return {
              contacttext: 'Contact Mr. Pool'
            }
        },
        computed: {
          ...mapGetters({
            contactEmail: 'data/contact_email',
            contactPhone: 'data/contact_phone'
          })
        },
        methods: {
          dial (number) {
              window.location ='tel:'+number;
          },
          sendmail (address ){
              window.location = 'mailto:'+address;
          },
        }
    }
</script>

<style lang="sass">
.v-bottom-navigation 
  button 
      span
          color: #fff

  .v-btn
    >.v-btn__content
      color: #fff
      
      .v-icon
        color: #fff
        margin: 0 auto!important
  
.contact-text
  span 
    font-size: 18px
    letter-spacing: 0

.call-button 
  border-right: 1px solid #2380dc
</style>